export default "__VITE_ASSET__DGhZ_rh2__"